<template>
  <span class="tooltip-wrapper">
    <span class="tooltip-wrapper__item"><slot /></span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AnswerTooltip',
  setup() {
    return {};
  }
});
</script>

<style lang="scss">
.poll .question__answers .question__answer-item {
  &.question__answer-item--paused {
    .tooltip-wrapper {
      position: absolute;
      left: 50%;
      top: 12.8px;
      top: 0.8rem;
      z-index: 1;
      cursor: pointer;

      &__item {
        position: absolute;
        bottom: 56px;
        bottom: 3.5rem;
        left: 50%;
        padding: 0.6rem 1rem 0.7rem;
        width: 480px;
        width: 30rem;
        background: #292828;
        border-radius: 0.4rem;
        opacity: 0;
        transform: translateX(-50%) translateY(1rem) translateZ(0);
        color: #9e9e9e;
        font-weight: 400;
        font-size: 25.6px;
        font-size: 1.6rem;
        line-height: 28.8px;
        line-height: 1.8rem;
        transition:
          visibility 0ms linear 0.15s,
          opacity 0.15s linear,
          transform 0.15s ease;
        z-index: 10;
        visibility: hidden;
        pointer-events: none;
        backface-visibility: hidden;
        will-change: transform, opacity;
      }
    }
    &:hover .tooltip-wrapper__item {
      opacity: 1;
      -webkit-transform: translateX(-50%) translateY(0) translateZ(0);
      transform: translateX(-50%) translateY(0) translateZ(0);
      visibility: visible;
      -webkit-transition-delay: 0ms;
      transition-delay: 0ms;
    }
  }
}
</style>
